import * as mat4 from './glMatrix/mat4';
import * as vec3 from './glMatrix/vec3';

let _vector = vec3.create()

class Plane {
	constructor() {
		this.normal = vec3.create();
		this.w      = 0;
	}
	distanceToPoint( p ) {
		return vec3.dot(this.normal, p ) + this.w;
	}
	setComponents(x,y,z,w) {
		vec3.set(this.normal, x,y,z)
		this.w = w;
		return this;
	}
	normalize(){
		let inverseNormalLength = 1.0 / vec3.length(this.normal);
		vec3.scale( this.normal, this.normal, inverseNormalLength );
		this.w *= inverseNormalLength;
		return this;
	}
}

export default class Frustum {
	constructor() {
		this.planes = []
		for ( var i = 0; i < 6; i ++ ) {
			this.planes.push( new Plane() )
		}
    }
    intersectsSphere( sphere ) {
        for ( let i = 0; i < 6; i ++ ) {
            let dist = this.planes[ i ].distanceToPoint( sphere.center );
            if ( dist < -sphere.radius ) {
                return false;
            }
        }
        return true;
    }
	intersectsBox( box ) {
		var planes = this.planes;
		for ( var i = 0; i < 6; i ++ ) {
			var plane = planes[ i ];
			_vector[0] = plane.normal[0] > 0 ? box.max[0] : box.min[0];
			_vector[1] = plane.normal[1] > 0 ? box.max[1] : box.min[1];
			_vector[2] = plane.normal[2] > 0 ? box.max[2] : box.min[2];
			if ( plane.distanceToPoint( _vector ) < 0 ) {
				return false;
			}
		}
		return true;
	}
	setFromProjectionMatrix( m ) {
		this.planes[ 0 ].setComponents( m[3] - m[ 0 ], m[7] - m[4], m[11] - m[8], m[15] - m[12] ).normalize();
		this.planes[ 1 ].setComponents( m[3] + m[ 0 ], m[7] + m[4], m[11] + m[8], m[15] + m[12] ).normalize();
		this.planes[ 2 ].setComponents( m[3] + m[1], m[7] + m[5], m[11] + m[9], m[15] + m[13] ).normalize();
		this.planes[ 3 ].setComponents( m[3] - m[1], m[7] - m[5], m[11] - m[9], m[15] - m[13] ).normalize();
		this.planes[ 4 ].setComponents( m[3] - m[2], m[7] - m[6], m[11] - m[10], m[15] - m[14] ).normalize();
        this.planes[ 5 ].setComponents( m[3] + m[2], m[7] + m[6], m[11] + m[10], m[15] + m[14] ).normalize();
	}
}
